var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBusinessRolesLarge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "69px",
    height: "60px",
    viewBox: "0 0 69 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Business Roles") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_Atoms",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a/icons/micro/70/business-roles-Final",
    transform: "translate(-1.000000, -5.000000)",
    stroke: "#D8D8DE",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Business-Roles",
    transform: "translate(2.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.3043478,11.5988401 L23.3043478,5.79942006 C23.3123537,2.59979557 25.9160978,0.00796921385 29.1304348,0 L37.8695652,0 C41.0832402,0.00955396783 43.6860543,2.60045454 43.6956522,5.79942006 L43.6956522,11.5988401",
    id: "Path",
    fill: "#EEF0F3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 11.6046395,
    width: 67,
    height: 46.3953605,
    rx: 8.75
  }), /*#__PURE__*/React.createElement("line", {
    x1: 33.5,
    y1: 26.1031897,
    x2: 33.5,
    y2: 23.2034797,
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8695652,26.0973903 L31.9473478,26.0973903 C30.0753624,26.0986917 28.467038,27.4207978 28.1118057,29.2503572 C27.7565734,31.0799165 28.7541472,32.9033698 30.4908261,33.5989401 L36.5033478,35.9912009 C38.2440597,36.6843584 39.2453255,38.5100492 38.8896867,40.3424101 C38.5340479,42.1747711 36.9216512,43.4978152 35.0468261,43.4956531 L29.1304348,43.4956531",
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 33.5,
    y1: 46.4011599,
    x2: 33.5,
    y2: 43.5014499,
    id: "Path"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessRolesLarge);
export default __webpack_public_path__ + "static/media/business-roles-large.9d67a2f710e1dfaed50d4c61f60d54fb.svg";
export { ForwardRef as ReactComponent };